import { useState } from 'react';
import { FiTrash2 } from 'react-icons/fi';
import { AnimatePresence, motion } from 'framer-motion';
import useDeleteAccount from '../../hooks/auth/useDeleteAccount'; // your hook
import styles from './DeleteAccount.module.css';
import globalButtonStyles from '../../styles/ButtonGradient.module.css';

const DeleteAccount = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { deleteMyAccount, loading } = useDeleteAccount();

  const handleDelete = async () => {
    try {
      await deleteMyAccount();
      setIsModalOpen(false);
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  return (
    <>
      <button
        className={styles.deleteBtn}
        onClick={() => setIsModalOpen(true)}
        aria-label="Delete Account"
      >
        <span className={styles.icon}>
          <FiTrash2 />
        </span>
      </button>

      <AnimatePresence>
        {isModalOpen && (
          <motion.div
            className={styles.overlay}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className={styles.modal}
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <button
                className={styles.closeButton}
                onClick={() => setIsModalOpen(false)}
                aria-label="Close delete modal"
              >
                ✕
              </button>
              <h2 className={styles.heading}>Are you sure you want to delete your account?</h2>
              <div className={styles.buttonRow}>
                <button
                  type="button"
                  className={`${globalButtonStyles.button} ${styles.acceptButton}`}
                  onClick={handleDelete}
                  disabled={loading}
                >
                  {loading ? "Deleting..." : "Yes, Delete"}
                </button>
                <button
                  type="button"
                  className={`${globalButtonStyles.button} ${styles.declineButton}`}
                  onClick={() => setIsModalOpen(false)}
                  disabled={loading}
                >
                  Cancel
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default DeleteAccount;